import { toRem, toRems } from 'helpers/theme'

/* eslint-disable quote-props */
const style = ({ theme, contain }) => ({
    ...(contain && {
        maxWidth: toRem(800),
        margin: '0 auto',
        padding: toRems([0, 20])
    }),
    article: {
        color: theme.colors.text.default,
        fontSize: toRem(14),
        lineHeight: '173%',
        [theme.breakpoints.up('md')]: {
            fontSize: toRem(20),
            lineHeight: '180%'
        },
        '& h1, & h2, & h3, & h4': {
            color: theme.colors.text.goldDark,
            fontFamily: theme.typography.font.primary,
            marginBottom: toRem(20),
            marginTop: 0,
            lineHeight: '140%',
            [theme.breakpoints.up('lg')]: {
                lineHeight: '150%'
            }
        },
        '& > * + h2, > * + h2, > * + h3, > * + h4': {
            marginTop: toRem(50)
        },
        '& h1, h2': {
            fontSize: toRem(20),
            [theme.breakpoints.up('lg')]: {
                fontSize: toRem(24)
            }
        },
        h3: {
            fontSize: toRem(18),
            [theme.breakpoints.up('lg')]: {
                fontSize: toRem(22)
            }
        },
        h4: {
            fontSize: toRem(16),
            [theme.breakpoints.up('lg')]: {
                fontSize: toRem(20)
            }
        },
        p: {
            marginBottom: toRem(20),
            fontSize: toRem(14),
            lineHeight: '173%',
            [theme.breakpoints.up('lg')]: {
                fontSize: toRem(20),
                lineHeight: '180%'
            }
        },
        '& > *:last-child': {
            marginBottom: 0
        },
        a: {
            color: theme.colors.text.goldDark,
            textDecoration: 'underline',
            transition: 'color 300ms ease-in-out 0ms',
            '&:hover': {
                color: theme.colors.text.goldLight
            }
        },
        img: {
            borderRadius: toRem(4)
        },
        ul: {
            padding: 0,
            margin: toRems([0, 0, 20, 0]),
            listStyle: 'none',
            [theme.breakpoints.up('lg')]: {
                margin: toRems([40, 0, 20, 0])
            },
            li: {
                marginBottom: toRem(10),
                paddingLeft: toRem(30),
                position: 'relative',
                lineHeight: 'inherit',
                fontSize: 'inherit',
                '&::before': {
                    content: '""',
                    display: 'block',
                    position: 'absolute',
                    top: 11,
                    left: 0,
                    width: 20,
                    height: 2,
                    background: theme.colors.background.goldDark,
                    [theme.breakpoints.up('md')]: {
                        top: 17
                    }
                }
            }
        },
        ol: {
            padding: 0,
            margin: toRems([0, 0, 20, 0]),
            listStyle: 'none',
            counterReset: 'numberedList',
            [theme.breakpoints.up('lg')]: {
                margin: toRems([40, 0, 40, 0])
            },
            li: {
                marginBottom: toRem(20),
                paddingLeft: toRem(30),
                position: 'relative',
                lineHeight: 'inherit',
                fontSize: 'inherit',
                [theme.breakpoints.up('md')]: {
                    paddingLeft: toRem(40)
                },

                '&::before': {
                    position: 'absolute',
                    top: 0,
                    right: 'calc(100% - 20px)',
                    counterIncrement: 'numberedList',
                    content: 'counter(numberedList, decimal-leading-zero) "."',
                    color: theme.colors.goldLight,
                    [theme.breakpoints.up('md')]: {
                        right: 'calc(100% - 30px)'
                    }
                }
            }
        },
        '& .wp-block-image, & .wp-block-embed': {
            '& img': {
                maxWidth: '100%',
                height: 'auto'
            },
            '& figure': {
                margin: 0,
                marginBottom: toRem(20)
            },
            '& figcaption': {
                marginTop: toRem(10),
                fontStyle: 'italic',
                fontSize: toRem(10),
                lineHeight: '180%',
                [theme.breakpoints.up('lg')]: {
                    fontSize: toRem(14),
                    lineHeight: '173%',
                    textAlign: 'center'
                }
            }
        },
        '& .wp-block-embed.is-type-video': {
            marginLeft: 0,
            marginRight: 0,
            [theme.breakpoints.up('lg')]: {
                width: '140%',
                marginLeft: '-20%',
                marginTop: toRem(105),
                marginBottom: toRem(85)
            },
            [theme.breakpoints.up('1290')]: {
                width: '178%',
                marginLeft: '-39%'
            },

            '& .wp-block-embed__wrapper': {
                position: 'relative',
                paddingTop: '56.25%'
            },

            iframe: {
                position: 'absolute',
                top: '0',
                left: '0',
                width: '100%',
                height: '100%'
            }
        },
        '& .wp-block-image': {
            maxWidth: '100%',
            marginLeft: 0,
            marginRight: 0,
            marginTop: toRem(20),
            marginBottom: toRem(20),
            '& figure.aligncenter, & figure.alignleft, & figure.alignright': {
                display: 'table',
                marginLeft: 0,
                marginRight: 0
            },
            '& figure.alignleft, & figure.alignright': {
                marginBottom: toRem(20),
                maxWidth: '50%'
            },
            '& figure.aligncenter': {
                marginBottom: toRem(30),
                marginLeft: 'auto',
                marginRight: 'auto'
            },
            '& figure.alignleft': {
                float: 'left',
                marginRight: toRem(20)
            },
            '& figure.alignright': {
                float: 'right',
                marginLeft: toRem(20)
            },
            '&.is-style-full-width, &.size-full': {
                ...(contain && {
                    display: 'block',
                    margin: toRems([55, -20, 45, -20]),
                    width: `calc(100% + ${toRem(40)})`,
                    maxWidth: 'none',
                    [theme.breakpoints.up('lg')]: {
                        width: '140%',
                        marginLeft: '-20%',
                        marginTop: toRem(105),
                        marginBottom: toRem(85)
                    },
                    [theme.breakpoints.up('1290')]: {
                        width: '178%',
                        marginLeft: '-39%'
                    },
                    '& figcaption': {
                        paddingLeft: toRem(20),
                        [theme.breakpoints.up('lg')]: {
                            paddingLeft: 0
                        }
                    }
                })
            }
        },
        '& .wp-block-pullquote blockquote, blockquote.wp-block-quote': {
            margin: toRems([30, 0, 30, 0]),
            padding: toRems([0, 0, 0, 30]),
            position: 'relative',
            ...(contain && {
                marginLeft: toRem(-20),
                padding: toRems([0, 0, 0, 20])
            }),
            [theme.breakpoints.up('lg')]: {
                margin: toRems([80, 0, 80, 0]),
                padding: toRems([0, 0, 0, 40]),
                ...(contain && {
                    marginLeft: toRem(-40)
                })
            },
            '&::before': {
                content: '""',
                width: 4,
                height: '100%',
                position: 'absolute',
                left: 0,
                top: 0,
                background: theme.colors.background.goldDark,
                borderRadius: 4
            },
            '& p': {
                display: 'block',
                marginBottom: toRem(14),
                fontSize: toRem(20),
                lineHeight: '140%',
                [theme.breakpoints.up('lg')]: {
                    fontSize: toRem(40),
                    lineHeight: '130%'
                }
            },
            '& cite': {
                fontStyle: 'italic',
                fontSize: toRem(14)
            }
        },
        '& .wp-block-button__link': {
            display: 'inline-block',
            padding: toRems([10, 20, 10, 20]),
            background: theme.colors.goldDark,
            color: theme.colors.black,
            borderRadius: '100px',
            textDecoration: 'none',
            fontSize: toRem(12),
            fontWeight: 500,

            [theme.breakpoints.up('lg')]: {
                fontSize: toRem(16),
                marginTop: toRem(30),
                padding: toRems([10, 40, 10, 40])
            }
        },
        '& .has-text-align-right, & .wp-block-buttons.alignright': {
            textAlign: 'right'
        },
        '& .has-text-align-center, & .wp-block-buttons.aligncenter': {
            textAlign: 'center'
        }
    }
})

export default style
